import React from "react";
import {
  SkeletonBlock,
  SkeletonContainer,
  SkeletonRow,
} from "./VisitsScheduleSkeleton";

export default function VisitsScheduleSkeletonLoader() {
  return (
    <SkeletonContainer>
      <SkeletonRow>
        <SkeletonBlock $height="3rem" $width="5rem" />
        <SkeletonBlock $height="1rem" $width="60%" />
      </SkeletonRow>
      <SkeletonBlock $height="1px" />
      {[1, 2, 3].map((item) => (
        <SkeletonRow key={item}>
          <SkeletonBlock $height="2.5rem" $width="2.5rem" />
          <SkeletonBlock $height="2.5rem" />
        </SkeletonRow>
      ))}
    </SkeletonContainer>
  );
}
